export { default } from "./QappLogo"
